export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/getLocation.74370420.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};